import React, { useState } from 'react'
import styled from 'styled-components'
import { Col, media, Row } from 'styled-bootstrap-grid'

import { H1, H4, P } from '@components/typography'
import Section from '@components/layout/Section/Section'
import SectionHeading from '@components/layout/Section/SectionHeading/SectionHeading'
import ContactForm from '@components/form/ContactForm'

const Address = styled(Row)`
  padding: 20px;
`

const Important = styled(H4)`
  font-size: 19px;
  font-weight: 400;
`

const Country = styled(Important)`
  font-size: 21px;
`

const PhoneNumber = styled(P)`
  font-weight: ${props => (props.bold ? 400 : 300)};
  margin-bottom: 10px;
`

const FlexRow = styled(Row)`
  flex-wrap: wrap-reverse;
`

const SuccessCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${props => props.theme.colors.secondary};
`

const FormCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const SuccessMessage = styled.div`
  padding: 30px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: ${props => props.theme.colors.black};
  ${media.md`
    font-size: 20px;
  `};
`

const Contact = () => {
  const [completed, setCompleted] = useState(false)
  return (
    <>
      <H1>Contact Martin Warner and his team for help to launch your own successful business.</H1>

      <Section>
        <SectionHeading heading="Get in Touch" />
        <FlexRow>
          <Col md={6}>
            {/* <Address>
              <Col md={3}>
                <Country>USA</Country>
              </Col>
              <Col md={9}>
                <Important>New York City Corporate Office</Important>

                <P>
                  469 7th Avenue
                  <br />
                  12th Floor
                  <br />
                  New York, NY, 10018
                </P>

                <div>
                  <PhoneNumber bold>US Phone Numbers</PhoneNumber>
                  <PhoneNumber>
                    US Office:
                    <br />
                    +1 212 359 9510
                  </PhoneNumber>
                  <PhoneNumber>
                    Speak to a Program Specialist:
                    <br />
                    +1 908 608 7774
                  </PhoneNumber>
                </div>
              </Col>
            </Address> */}

            <Address>
              <Col md={3}>
                <Country>UK</Country>
              </Col>
              <Col md={9}>
                <Important>London Corporate Office</Important>

                <P>
                  7 Bell Yard
                  <br />
                  London
                  <br />
                  WC2A 2JR
                </P>
                <div>
                  <PhoneNumber bold>UK Phone Numbers</PhoneNumber>
                  <PhoneNumber>
                    UK Office:
                    <br />
                    +44 207 1835 846
                  </PhoneNumber>
                  <PhoneNumber>
                    Speak to a Program Specialist:
                    <br />
                    +44 753 4423 675
                  </PhoneNumber>
                </div>
              </Col>
            </Address>
          </Col>

          {completed ? (
            <SuccessCol md={6}>
              <SuccessMessage>
                Thanks for your message, a Program Specialist will be in touch soon!
              </SuccessMessage>
            </SuccessCol>
          ) : (
            <FormCol md={6}>
              <ContactForm onCompleted={() => setCompleted(true)} formHeading="" />
            </FormCol>
          )}
        </FlexRow>
      </Section>
    </>
  )
}

export default Contact
